(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('UserActivationDetailController', UserActivationDetailController);

    UserActivationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'UserActivation', 'CustomUser'];

    function UserActivationDetailController($scope, $rootScope, $stateParams, previousState, entity, UserActivation, CustomUser) {
        var vm = this;

        vm.userActivation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:userActivationUpdate', function(event, result) {
            vm.userActivation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
